import React, { useContext, useEffect, useState, Fragment } from "react";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import cx from "classnames";

import _CK from "@util/cookie";
import _API from "@util/api";

import useIam from "@hook/useIam";
import useScript from "@hook/useScript";
import useCss from "@hook/useCss";

import { AppContext } from "@component/AppProvider";

import Loading from "@component/UI/Loading";
import Header from "./Header";
import Footer from "./Footer";
import parse from "html-react-parser";

const Layout = ({ children, breadcrumb }) => {
    const { site } = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [popup, setPopup] = useState([]);

    useIam({
        onError: (e) => {
            _CK.clearAuth();
            document.location.href = "/";
        },
    });

    //useScript("/assets/js/ui.js");
    if (site?.siteCode) {
        useScript(`${process.env.CDN_URL}/resource/${site.siteCode}.js`);
        //     useCss(`${process.env.CDN_URL}/resource/${site.siteCode}.css`);
    }

    const parseAndOpenWindowOpen = (str) => {
        const match = str.match(/window\.open\(([^)]+)\)/);
        if (!match) return false;
        const args = match[1].split(",").map((s) => s.trim());
        const url = args[0].replace(/^['"]|['"]$/g, "");
        const name = args[1]?.replace(/^['"]|['"]$/g, "") || "_blank";
        const features = args.slice(2).join(",");
        window.open(url, name, features);
        return true;
    };

    const handleOnClick = (e) => {
        if (e?.target instanceof HTMLAnchorElement) {
            e.preventDefault();
            const { origin } = window.location;

            const onclickAttr = e.target.getAttribute("onclick") || "";
            const hrefAttr = e.target.getAttribute("href") || "";

            // Case 1: onclick 속성에 window.open이 있는 경우 (이미 실행됨, navigate만 막음)
            if (onclickAttr.includes("window.open")) {
                return;
            }

            // Case 2: href="javascript:window.open(...)" 인 경우
            if (hrefAttr.startsWith("javascript:") && hrefAttr.includes("window.open")) {
                parseAndOpenWindowOpen(hrefAttr);
                return;
            }

            if (e.target.target?.toLowerCase() === "_blank") {
                window.open(e.target.href);
            } else {
                navigate(e.target.href?.replace(origin, ""));
            }
        }
    };

    useEffect(() => {
        window?.addEventListener("click", handleOnClick);

        return () => {
            window?.removeEventListener("click", handleOnClick);
        };
    }, []);

    const loadPopup = () => {
        _API.get({ path: "/site/bbs", data: { code: "notice", isPopup: "Y" } })
            .then((res) => {
                const { list } = res.data;
                setPopup(list);
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    useEffect(() => {
        if (site.siteCode && location.pathname === "/") {
            loadPopup();
        } else {
            setPopup([]);
        }
    }, [site, location]);

    useEffect(() => {
        const dimElements = document.querySelectorAll(".dim");
        dimElements.forEach((element) => {
            element.style.display = "none";
        });
    }, [location?.pathname]);

    return (
        <Fragment>
            <Header />
            <section id="container">
                {site?.visual && parse(site.visual)}
                {children}
            </section>
            <Footer />
            {popup?.map((pop, index) => (
                <Popup key={index} data={pop} />
            ))}
            <div class="dim"></div>
        </Fragment>
    );
};

const Popup = (props) => {
    const { data } = props;
    const [close, setClose] = useState(true);
    const [check, setCheck] = useState(false);

    const onPopupToday = (e) => {
        setCheck(e.target.checked);
    };

    const onPopupClose = () => {
        if (check) {
            _CK.set(`POPUP-CLOSE-${data?.idx}`, "Y", { expires: new Date(Date.now() + 86400000) });
        }
        setClose(true);
    };

    useEffect(() => {
        if (_CK.get(`POPUP-CLOSE-${data?.idx}`) && _CK.get(`POPUP-CLOSE-${data?.idx}`) === "Y") {
            setClose(true);
        } else {
            setClose(false);
        }
    }, [_CK.get(`POPUP-CLOSE-${data?.idx}`)]);

    if (close) {
        return "";
    }

    return (
        <div
            className="noticePopup"
            style={{ zIndex: "1005", position: "absolute", top: data?.popupTop || 0, left: data?.popupLeft || 0, width: data?.popupWidth || 100, height: data?.popupHeight || 100 }}
        >
            <h1 className={cx({ tit: data?.popupSkin === "1", tit2: data?.popupSkin === "2" })}>{data?.title}</h1>
            <div className="popCont" style={{ background: "#ffffff" }}>
                <p
                    className="txtBox"
                    dangerouslySetInnerHTML={{
                        __html: data?.content,
                    }}
                ></p>
                {data?.fileList?.map((file, index) => (
                    <p className="download" key={index}>
                        File {parseInt(index) + 1} :{" "}
                        <a href={file.signedUrl} target="_blank">
                            {file.name}
                        </a>
                    </p>
                ))}

                {data?.popupDetailUrl && (
                    <a href={data?.popupDetailUrl} target="_blank" className="btn_detail">
                        View more
                    </a>
                )}
            </div>
            <div className="bottom">
                <label>
                    <input type="checkbox" onChange={onPopupToday} /> Don't open a pop-up today
                </label>
                <a onClick={onPopupClose}>[Close]</a>
            </div>
        </div>
    );
};

export default Layout;
